export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  submitBtn: "auth-submit-btn",
  logoutBtn: "auth-logout-btn",
  errorMsg: "auth-error-msg",
  forgotLink: "auth-forgot-link",
  forgotEmailInput: "auth-forgot-email-input",
  forgotSubmitBtn: "auth-forgot-submit-btn",
  twoFactorCode: "auth-2fa-code",
  twoFactorSubmit: "auth-2fa-submit",
};

export const NAV = {
  dashboard: "nav-dashboard",
  contacts: "nav-contacts",
  bookings: "nav-bookings",
  calendar: "nav-calendar",
  cleaning: "nav-cleaning",
  campaigns: "nav-campaigns",
  templates: "nav-templates",
  properties: "nav-properties",
  statements: "nav-statements",
  finance: "nav-finance",
  compliance: "nav-compliance",
  reports: "nav-reports",
  team: "nav-team",
  settings: "nav-settings",
  userMenu: "nav-user-menu",
};

export const REPORTS = {
  root: "reports-root",
  monthInput: "reports-month",
  refreshBtn: "reports-refresh",
  downloadCsv: "reports-download-csv",
  row: (id) => `reports-row-${id}`,
};

export const CALENDAR = {
  root: "calendar-root",
  cell: (pid, date) => `cal-cell-${pid}-${date}`,
  todayBtn: "calendar-today-btn",
  prevBtn: "calendar-prev-btn",
  nextBtn: "calendar-next-btn",
  editorSave: "calendar-editor-save",
  editorRate: "calendar-editor-rate",
  editorMin: "calendar-editor-min-nights",
  editorBlocked: "calendar-editor-blocked",
};

export const CLEANING = {
  root: "cleaning-root",
  card: (id) => `cleaning-card-${id}`,
  moveTo: (id, status) => `cleaning-move-${id}-${status}`,
  column: (status) => `cleaning-col-${status}`,
};

export const DIRECT_BOOK = {
  root: "direct-book-root",
  checkIn: "direct-book-checkin",
  checkOut: "direct-book-checkout",
  quoteBtn: "direct-book-quote-btn",
  totalRow: "direct-book-total",
};

export const CHANNEL_MGR = {
  toggle: "channel-mgr-toggle",
};

export const DASH = {
  root: "dashboard-root",
  cardContacts: "dash-card-contacts",
  cardGuests: "dash-card-guests",
  cardContractors: "dash-card-contractors",
  cardProperties: "dash-card-properties",
  cardCampaigns: "dash-card-campaigns",
  cardEmails: "dash-card-emails",
  upcomingList: "dash-upcoming-list",
  recentContacts: "dash-recent-contacts",
  recentCampaigns: "dash-recent-campaigns",
};

export const CONTACTS = {
  root: "contacts-root",
  addBtn: "contacts-add-btn",
  searchInput: "contacts-search-input",
  tabAll: "contacts-tab-all",
  tabGuest: "contacts-tab-guest",
  tabContractor: "contacts-tab-contractor",
  tabSupplier: "contacts-tab-supplier",
  tabOwner: "contacts-tab-owner",
  table: "contacts-table",
  row: (id) => `contacts-row-${id}`,
  dialog: "contacts-dialog",
  saveBtn: "contacts-save-btn",
  fieldFirstName: "contacts-field-first-name",
  fieldLastName: "contacts-field-last-name",
  fieldEmail: "contacts-field-email",
  fieldPhone: "contacts-field-phone",
  fieldCompany: "contacts-field-company",
  fieldType: "contacts-field-type",
  fieldTrade: "contacts-field-trade",
  fieldTags: "contacts-field-tags",
  fieldNotes: "contacts-field-notes",
  fieldAddress: "contacts-field-address",
  fieldBirthday: "contacts-field-birthday",
  segmentChip: (k) => `contacts-segment-chip-${k}`,
  recomputeBtn: "contacts-recompute-btn",
};

export const CAMPAIGNS = {
  root: "campaigns-root",
  newBtn: "campaigns-new-btn",
  nameInput: "campaigns-name-input",
  subjectInput: "campaigns-subject-input",
  htmlInput: "campaigns-html-input",
  segmentType: "campaigns-segment-type",
  previewBtn: "campaigns-preview-btn",
  sendBtn: "campaigns-send-btn",
  templateSelect: "campaigns-template-select",
  testEmailInput: "campaigns-test-email-input",
  sendTestBtn: "campaigns-send-test-btn",
  analyticsCard: "campaigns-analytics-card",
};

export const STATEMENTS = {
  root: "statements-root",
  propertySelect: "statements-property-select",
  monthSelect: "statements-month-select",
  yearSelect: "statements-year-select",
  downloadBtn: (id) => `statements-download-${id}`,
  downloadRowBtn: "statements-download-row-btn",
  table: "statements-table",
};

export const CONTACT_DETAIL = {
  root: "contact-detail-root",
  editBtn: "contact-edit-btn",
  deleteBtn: "contact-delete-btn",
  tabOverview: "contact-tab-overview",
  tabStays: "contact-tab-stays",
  tabNotes: "contact-tab-notes",
  tabCampaigns: "contact-tab-campaigns",
  noteInput: "contact-note-input",
  noteAddBtn: "contact-note-add-btn",
  addStayBtn: "contact-add-stay-btn",
};

export const BOOKINGS = {
  root: "bookings-root",
  addBtn: "bookings-add-btn",
  table: "bookings-table",
  fieldContact: "bookings-field-contact",
  fieldProperty: "bookings-field-property",
  fieldCheckIn: "bookings-field-check-in",
  fieldCheckOut: "bookings-field-check-out",
  saveBtn: "bookings-save-btn",
};

export const TEMPLATES = {
  root: "templates-root",
  addBtn: "templates-add-btn",
  nameInput: "templates-name-input",
  subjectInput: "templates-subject-input",
  htmlInput: "templates-html-input",
  saveBtn: "templates-save-btn",
};

export const PROPERTIES = {
  root: "properties-root",
  addBtn: "properties-add-btn",
  nameInput: "properties-name-input",
  addressInput: "properties-address-input",
  bedroomsInput: "properties-bedrooms-input",
  saveBtn: "properties-save-btn",
  icalAirbnbInput: "properties-ical-airbnb",
  icalBookingInput: "properties-ical-booking",
  icalSyncNowBtn: "properties-ical-sync-now",
  guestBookLinkBtn: "properties-guestbook-link",
  guestBookWifiSsid: "properties-gb-wifi-ssid",
  guestBookCheckout: "properties-gb-checkout",
  guestBookRecs: "properties-gb-recs",
  guestBookRules: "properties-gb-rules",
  guestBookEmergency: "properties-gb-emergency",
  guestBookEnabled: "properties-gb-enabled",
};

export const SETTINGS = {
  root: "settings-root",
  currentPasswordInput: "settings-current-pw",
  newPasswordInput: "settings-new-pw",
  confirmPasswordInput: "settings-confirm-pw",
  savePasswordBtn: "settings-save-pw",
  twoFactorToggle: "settings-2fa-toggle",
};

export const TEAM = {
  root: "team-root",
  inviteBtn: "team-invite-btn",
  inviteEmail: "team-invite-email",
  inviteName: "team-invite-name",
  inviteRole: "team-invite-role",
  sendInviteBtn: "team-send-invite-btn",
  row: (id) => `team-row-${id}`,
  resendWelcome: (id) => `team-resend-welcome-${id}`,
};

export const GUESTBOOK = {
  root: "guestbook-root",
  wifi: "guestbook-wifi",
  checkout: "guestbook-checkout",
  recs: "guestbook-recs",
  rules: "guestbook-rules",
  emergency: "guestbook-emergency",
};
